export default {"id":"a75616c5","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}